export default __webpack_public_path__ + "static/media/biofit-builder-series-MVMT.270553a9.png";